<div class="file-upload-container">
  <!-- Info Messages -->
  <div>
    <ng-container *ngIf="effectiveMinFiles > 0">
      <div class="d-flex align-items-start mb-1">
        <div><small><i class="fa-light fa-file-circle-info me-2 pt-1 text-primary"></i></small></div>
        <div class="d-flex align-items-center">
          <small>{{'General.AtLeast' | translate}} {{ effectiveMinFiles }}
            {{ effectiveMinFiles === 1 ? 'Datei' : 'Dateien' }} {{'General.UploadVerb' | translate}}</small>
          <small *ngIf="hasMinimumFiles" class="ms-2 text-success">
            <i class="fa-light fa-circle-check me-1"></i>
          </small>
        </div>
      </div>
    </ng-container>

    <div class="mb-3">
      <div class="d-flex align-items-start">
        <div><small><i class="fa-light fa-file-circle-info me-2 pt-1 text-primary"></i></small></div>
        <div><small>{{ 'General.InformationUploadSize' | translate }}</small></div>
      </div>
    </div>

    <!-- Hidden file input -->
    <input
      type="file"
      multiple
      #fileInput
      style="display: none"
      (change)="onManualFileSelect($event)"
      [accept]="acceptedFileTypes"
    />

    <!-- Drag & Drop Zone -->
    <ngx-file-drop
      *ngIf="shouldShowUploadArea"
      [dropZoneLabel]="'Dateien hierher ziehen'"
      (onFileDrop)="onFileDrop($event)"
      (click)="fileInput.click()"
      class="file-drop-zone h-100 border bg-light border-primary text-primary rounded-2 mt-1 text-center d-flex flex-column justify-content-center align-items-center"
      style="min-height: 60px; cursor: pointer;">
      <ng-template ngx-file-drop-content-tmp>
        <div class="upload-container w-100 text-center"
             [class.drag-active]="isDragging"
             [class.upload-in-progress]="isUploading"
             [@uploadArea]="uploadAreaState">
          <i class="fa-solid fa-cloud-arrow-up fs-3 text-dark mb-3"></i>
          <p class="fs-6 mb-0 text-dark">{{'General.UploadFileMessage' | translate}}</p>
        </div>
      </ng-template>
    </ngx-file-drop>

    <div *ngIf="hasMinimumFiles && effectiveMinFiles > 0" class="rounded-4 p-3 bg-light mt-3">
      <small class="text-success mt-2">
        <i class="fa-solid fa-circle-check me-1"></i>{{'General.UploadSuccess' | translate}}
      </small>
    </div>

    <!-- File List and Upload Progress -->
    <div *ngIf="files.length > 0" class="mt-4">
      <ul class="list-group">
        <li class="list-group-item border border-primary rounded-3 mb-2" *ngFor="let file of files; let i = index">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center overflow-hidden" style="max-width: 80%">
              <i class="fa-light fa-file me-2 text-primary"></i>
              <span>{{ file.name }}</span>
            </div>
            <span class="badge bg-light text-dark rounded-pill">{{'General.File' | translate}} #{{ uploadedFiles.length + i + 1 }}</span>
          </div>
          <div *ngIf="uploadProgress[file.name] !== undefined" class="progress mt-2" style="height: 5px;">
            <div
              class="progress-bar bg-primary"
              role="progressbar"
              [style.width]="uploadProgress[file.name] + '%'"
              [attr.aria-valuenow]="uploadProgress[file.name]"
              aria-valuemin="0"
              aria-valuemax="100">
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- Uploaded Files Section -->
  <div class="uploaded-files" #uploadedFilesSection *ngIf="shouldShowUploadedFiles">
    <h3>{{'General.UploadedFilesTitle' | translate}}</h3>
    <div class="file-list">
      <div class="file-item" *ngFor="let file of filteredFiles">
        <div class="file-info">
          <i class="fas fa-file"></i>
          <span class="file-name">{{ file.fileDisplayName || file.fileName }}</span>
        </div>
        <button class="delete-button" (click)="deleteFile(file.id)">
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<ng-template #deleteConfirmModal>
  <div class="modal-header">
    <h4 class="modal-title">{{'General.ConfirmationDelete' | translate}}</h4>
  </div>
  <div class="modal-body break-word">
    <p>Möchten Sie die Datei "{{ fileToDelete?.fileDisplayName || fileToDelete?.fileName }}" wirklich löschen?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelDelete()">{{'General.ConfirmationAbbort' | translate}}</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">{{'General.ConfirmationDelete' | translate}}</button>
  </div>
</ng-template>
